export const navItems = [
  { to: '/', label: 'الرئيسية' },
  { to: '/services', label: 'ما تقدمه النقابة الفرعية' },
  { to: '/offers', label: 'العروض الحصرية' },
  { to: '/activities', label: 'أنشطة النقابة' },
  { to: '/contracts', label: 'تعاقدات النقابة' },
  { to: '/lectures', label: 'الندوات والمحاضرات' },
  { to: '/judgments', label: 'أحكام النقض' },
  { to: '/books', label: 'كتب قانونية' },
  { to: '/government-links', label: 'المواقع الحكومية', dropdown: true },
  { to: '/complaints', label: 'الاستعلامات والشكاوى' },
  { to: '/contact', label: 'تواصل معنا' },
];
